import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
import { globalClasses as buttonGlobalClasses } from "../../Button/Button.styles";
export var styles = memoizeStyle({
  icon: function icon() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      text-align: center;\n    "])));
  },
  description: function description() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      text-align: center;\n    "])));
  },
  description5_3: function description5_3(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.miniModalDescriptionFontSize, t.miniModalDescriptionLineHeight);
  },
  title: function title() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      text-align: center;\n    "])));
  },
  titleWithIcon: function titleWithIcon(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      margin-top: ", ";\n    "])), t.miniModalTitleMarginTop);
  },
  actions: function actions() {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      justify-content: stretch;\n      text-align: center;\n\n      .", " {\n        width: 100%;\n      }\n    "])), buttonGlobalClasses.root);
  },
  actionsIndent: function actionsIndent(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      padding: ", " 0;\n    "])), t.miniModalCancelIndent);
  },
  actionsRow: function actionsRow(t) {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      flex-direction: row;\n      > *:nth-of-type(1) {\n        margin-right: calc(", " / 2);\n      }\n      > *:nth-of-type(2) {\n        margin-left: calc(", " / 2);\n      }\n    "])), t.miniModalActionGap, t.miniModalActionGap);
  },
  actionsColumn: function actionsColumn(t) {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      flex-direction: column;\n      > *:nth-of-type(2) {\n        margin-top: ", ";\n      }\n      > *:nth-of-type(3) {\n        margin-top: ", ";\n      }\n    "])), t.miniModalActionGap, t.miniModalActionGap);
  }
});